import Header from "./Header";
import Footer from "./Footer";
import { Phone, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";
import JsonLd, { organizationLd, websiteLd } from "./JsonLd";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <JsonLd id="ld-organization" data={organizationLd} />
      <JsonLd id="ld-website" data={websiteLd} />
      <Header />
      <main className="flex-1">{children}</main>

      {/* Sticky mobile help bar */}
      <div
        data-testid="sticky-help-bar"
        className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-slate-200 shadow-[0_-2px_10px_rgba(0,0,0,0.04)] flex"
      >
        <a
          data-testid="sticky-call-counsellor"
          href="tel:+919000000000"
          className="flex-1 flex items-center justify-center gap-2 text-[#0369A1] py-3 font-medium text-sm"
        >
          <Phone size={18} /> Call Counsellor
        </a>
        <Link
          data-testid="sticky-whatsapp"
          to="/register"
          className="flex-1 flex items-center justify-center gap-2 bg-[#0F766E] text-white py-3 font-medium text-sm"
        >
          <MessageCircle size={18} /> Get Help
        </Link>
      </div>

      <Footer />
    </div>
  );
}
